import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "nes-container is-dark with-title mb-10"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Connect to a Farm", -1)
const _hoisted_5 = { class: "nes-field mb-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "farm" }, "Farm address:", -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center mb-5" }, " Farmer account is not found :( Create a new one? ", -1)
const _hoisted_12 = { class: "w-full text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FarmerDisplay = _resolveComponent("FarmerDisplay")!
  const _component_Vault = _resolveComponent("Vault")!

  return (!_ctx.wallet)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Please connect your wallet!"))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  id: "farm",
                  class: "nes-input is-dark",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.farm) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.farm]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.farmerAcc)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_FarmerDisplay, {
                key: _ctx.farmerAcc,
                farm: _ctx.farm,
                farmAcc: _ctx.farmAcc,
                farmer: _ctx.farmer,
                farmerAcc: _ctx.farmerAcc,
                class: "mb-10",
                onRefreshFarmer: _ctx.handleRefreshFarmer
              }, null, 8, ["farm", "farmAcc", "farmer", "farmerAcc", "onRefreshFarmer"]),
              _createVNode(_component_Vault, {
                key: _ctx.farmerAcc,
                class: "mb-10",
                vault: _ctx.farmerAcc.vault.toBase58(),
                onSelectedWalletNft: _ctx.handleNewSelectedNFT
              }, {
                default: _withCtx(() => [
                  (_ctx.farmerState === 'staked' && _ctx.selectedNFTs.length > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "nes-btn starforge is-primary mr-5",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addGems && _ctx.addGems(...args)))
                      }, " Add NFTs (resets staking) "))
                    : _createCommentVNode("", true),
                  (_ctx.farmerState === 'unstaked')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "nes-btn starforge is-success mr-5",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.beginStaking && _ctx.beginStaking(...args)))
                      }, " Begin staking "))
                    : _createCommentVNode("", true),
                  (_ctx.farmerState === 'staked')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "nes-btn starforge is-error mr-5",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                      }, " End staking "))
                    : _createCommentVNode("", true),
                  (_ctx.farmerState === 'pendingCooldown')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        class: "nes-btn starforge is-error mr-5",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                      }, " End cooldown "))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "nes-btn starforge is-warning",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.claim && _ctx.claim(...args)))
                  }, " Claim " + _toDisplayString(_ctx.availableA) + " $ALIEN / " + _toDisplayString(_ctx.availableB) + " USDC ", 1)
                ]),
                _: 1
              }, 8, ["vault", "onSelectedWalletNft"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_ctx.farmAccFetching)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Please wait fatching farmer account details... "))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        class: "flex mx-auto mt-16 text-white bg-indigo-500 border-0 py-2 px-8 focus:outline-none hover:bg-indigo-600 rounded text-lg is-primary",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                      }, " New Farmer ")
                    ])
                  ]))
            ]))
      ]))
}